
import Vue from 'vue';

export default Vue.component('form-alerts', {
  props: ['isSaved', 'hasError', 'hasFatalError', 'fatalErrorText'],
});
